import { useState } from "react";
import { Search } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { useShop } from "../context/ShopContext";

export default function TrackOrder() {
  const { connected } = useShop();
  const [order, setOrder] = useState("");
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    setResult(true);
  };

  return (
    <div>
      <PageHeader
        eyebrow="Order tracking"
        title="Where's my gear?"
        description="Enter your order number and the email used at checkout."
      />
      <div className="px-5 py-12 sm:px-10 lg:px-16">
        <Reveal>
          <form
            onSubmit={submit}
            data-testid="track-order-form"
            className="max-w-xl border border-border p-8"
          >
            <input
              value={order}
              onChange={(e) => setOrder(e.target.value)}
              required
              placeholder="ORDER NUMBER — E.G. #1001"
              data-testid="track-order-number-input"
              className="w-full border-b border-border bg-transparent py-3.5 font-mono text-xs uppercase tracking-[0.2em] placeholder:text-muted-foreground focus:border-signal focus:outline-none"
            />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="EMAIL ADDRESS"
              data-testid="track-order-email-input"
              className="mt-5 w-full border-b border-border bg-transparent py-3.5 font-mono text-xs uppercase tracking-[0.2em] placeholder:text-muted-foreground focus:border-signal focus:outline-none"
            />
            <button
              type="submit"
              data-testid="track-order-submit"
              className="mt-8 flex items-center gap-2 bg-signal px-8 py-4 font-mono text-xs font-bold uppercase tracking-[0.25em] text-white transition-colors hover:bg-signal/90"
            >
              <Search className="h-4 w-4" /> Track order
            </button>
          </form>
        </Reveal>

        {result && (
          <Reveal>
            <div
              data-testid="track-order-result"
              className="mt-8 max-w-xl border border-signal/40 bg-signal/5 p-8"
            >
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-signal">
                {connected ? "Tracking via your inbox" : "Tracking activates at launch"}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                {connected
                  ? "Live order status and carrier tracking links are sent to your email the moment your order ships, and are available inside your customer account. If something looks off, hit the contact page and the crew will sort it."
                  : "Order tracking goes live the moment the Shopify store is connected — Shopify sends carrier tracking links by email automatically, and status shows inside your customer account."}
              </p>
            </div>
          </Reveal>
        )}
      </div>
    </div>
  );
}
